import {useEffect} from '@wordpress/element';
import {sprintf} from '@wordpress/i18n';
import {i18n} from '../../../../utils';

export const useValidateCheckout = (
    {
        title,
        isExpress,
        paymentData,
        onCheckoutValidation
    }) => {
    useEffect(() => {
        if (!isExpress) {
            const unsubscribe = onCheckoutValidation(() => {
                // validate that the order has been created.
                if (!paymentData?.orderId) {
                    return {
                        type: 'failure',
                        errorMessage: sprintf(i18n.order_button_click, title)
                    }
                }
                return true;
            });
            return unsubscribe;
        }
    }, [isExpress, paymentData]);
}